<div class="values-registration">
    <div class="values-registration_main">
        <!-- Title -->
        <div class="app_title_background">
            <div class="app_title_header">
                <div class="app_title_text">
                    <button mat-icon-button aria-label="Back" (click)="goBack()">
                        <mat-icon aria-label="Back">arrow_back_ios</mat-icon>
                    </button>
                    <label class="title"><input type="text" hidden />Resource not found</label>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="change-password_general">
    <div class="change-password_content">
        <!-- <label class="title" for="">RESOURCE NOT FOUND</label> -->
        <label class="title" for="">We are sorry, the resource you tried to access has a problem, please contact
            support.</label>
        <div class="change-password_button">
            <button mat-flat-button color="primary" (click)="goBack()">RETURN</button>
            <button mat-flat-button color="accent" (click)="goToHome()">HOME</button>
        </div>
    </div>
</div>